"use client";

import React, { useState, useEffect } from "react";
import "./HomeWork.scss";
import { Link } from "react-router-dom";
import { ReactComponent as SideBtnBlack } from "../../assets/svg/side-btn-black.svg";

import {
  slidesData1,
  slidesData2,
  slidesData3,
  slidesData4,
} from "../../data/data";

const HomeWork = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === slidesData1.length - 1 ? 0 : prev + 1));
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="section homeWork" id="recent-works">
      <article className="homeWork__container container">
        <div className="homeWork__container--header">
          <h2 className="header__title">Recent</h2>
          <h3 className="homeWork__subtitle">Works</h3>
        </div>

        <div className="homeWork__container--content">
          <div className="homeWork__container--content-wrapper">
            <Link to="https://www.transcenddesignbuild.com" className="lefty">
              <div
                className="homeWork__container--content-left"
                style={{
                  backgroundImage: `url(${slidesData1[current]})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>

              <div className="homeWork__text-left">
                <h3>Drapme - Chauffeur service platform</h3>
                <p>Mobile App/Website - Product Design</p>
              </div>
            </Link>

            <Link to="/transcend-build-project" className="righty">
              <div
                className="homeWork__container--content-right"
                style={{
                  backgroundImage: `url(${slidesData2[current]})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>

              <div className="homeWork__text-right">
                <h3>Transcend Design & Build - Housing and Real Estate</h3>
                <p>Website Design - Branding</p>
              </div>
            </Link>

            <div to="/hypedive-project" className="lefty">
              <div
                className="homeWork__container--content-left"
                style={{
                  backgroundImage: `url(${slidesData3[current]})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>

              <div className="homeWork__text-left">
                <h3>Hypedive - Dj and Music</h3>
                <p>Branding</p>
              </div>
            </div>

            <div to="/deewealthdr-project" className="righty">
              <div
                className="homeWork__container--content-right"
                style={{
                  backgroundImage: `url(${slidesData4[current]})`,
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>

              <div className="homeWork__text-right">
                <h3>Deewealthdr - Financial Consultancy</h3>
                <p>Website Design - Branding</p>
              </div>
            </div>
          </div>
        </div>

        <Link to="/case-studies" className="homeWork__content-btn">
          <button className="homeWork__btn">
            <span> View all cases</span>
          </button>
          <SideBtnBlack />
        </Link>
      </article>
    </section>
  );
};

export default HomeWork;
